import { tasksSchema } from "@companies/shared/types/task";

import { FETCH_ERROR } from "../consts/fetch-error";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getTasks(project: string) {
  const response = await fetch(
    `${API_BASE_URL}/task?project=${encodeURIComponent(project)}`,
  );

  if (response.status === 401) {
    throw FETCH_ERROR.UNAUTHORIZED;
  } else if (!response.ok) {
    throw new Error("Failed to get tasks");
  }

  return tasksSchema.parse(await response.json());
}
